(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["santa-glow-collection"]) return;
  try {
    
document.addEventListener('click',function(e){
  var p=e.target.closest('[data-sg-pick]'),g=e.target.closest('[data-sg-goto]');
  if(!p&&!g)return;
  var root=document.querySelector('[data-sg]');if(!root)return;
  e.preventDefault();
  root.scrollIntoView({behavior:'smooth',block:'start'});
  if(p){var t=root.querySelectorAll('[data-sg-thumb]')[Number(p.getAttribute('data-sg-pick'))];if(t)setTimeout(function(){t.click()},400)}
});

  } catch(e) { console.error(e); }
})();
})();
